import type {
  BaseTypographyVariant,
  BoldTypographyVariant,
  TypographyVariant,
  TypographyVariantConfig,
} from '@iheartjane/reefer';
import { BASE_CONFIG } from '@iheartjane/reefer';

import { ObjectKeys } from '@jane/shared/util';

const mobileVariantConfigs: TypographyVariantConfig<BaseTypographyVariant> = {
  body: {
    ...BASE_CONFIG.components.Typography.variants['body'],
    fontWeight: 400,
    mobileStyles: {
      fontSize: '15px',
      lineHeight: '24px',
    },
  },
  header: {
    ...BASE_CONFIG.components.Typography.variants['header'],
    branded: true,
    fontWeight: 400,
    mobileStyles: {
      fontSize: '20px',
      lineHeight: '24px',
    },
  },
  huge: {
    ...BASE_CONFIG.components.Typography.variants['huge'],
    branded: true,
    fontWeight: 500,
    mobileStyles: {
      fontSize: '40px',
      lineHeight: '40px',
    },
  },
  mini: {
    ...BASE_CONFIG.components.Typography.variants['mini'],
    fontWeight: 400,
    mobileStyles: {
      fontSize: '13px',
      lineHeight: '16px',
    },
  },
  section: {
    ...BASE_CONFIG.components.Typography.variants['section'],
    branded: true,
    fontWeight: 400,
    mobileStyles: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  title: {
    ...BASE_CONFIG.components.Typography.variants['title'],
    branded: true,
    fontWeight: 500,
    mobileStyles: {
      fontSize: '28px',
      lineHeight: '32px',
    },
  },
  caps: {
    ...BASE_CONFIG.components.Typography.variants['caps'],
    fontWeight: 400,
    mobileStyles: {
      fontSize: '13px',
      lineHeight: '16px',
    },
  },
};

const boldMobileVariantConfig = ObjectKeys(mobileVariantConfigs)
  .map<TypographyVariantConfig<BoldTypographyVariant>>((value) => {
    const variantKey = String(`${value}-bold`) as BoldTypographyVariant;
    const obj: TypographyVariantConfig<string> = {
      [variantKey]: {
        ...mobileVariantConfigs[value],
        fontWeight: 600,
      },
    };
    return obj as TypographyVariantConfig<BoldTypographyVariant>;
  })
  .reduce((prev, curr) => ({ ...prev, ...curr }));

export const mobileTypographyVariants: TypographyVariantConfig<TypographyVariant> =
  {
    ...mobileVariantConfigs,
    ...boldMobileVariantConfig,
  };
